<template>
    <v-dialog
      v-model="confirmDialog"
      persistent
      max-width="450"
      class="action-channel-dialog"
    >
      <v-card v-if="channelAction">
        <v-card-title class="text-h5">
          <span v-if="member">{{ capitalizeFirstLetter($t('chat.contextMenu')[channelAction]) }}</span>
          <span v-else>{{ $t('chat.confirmDialog.title', { channelAction: capitalizeFirstLetter($t('chat.contextMenu')[channelAction]) }) }}</span>
        </v-card-title>
        <br/>
        <v-card-text v-if="channel">
          <span v-if="member">
            <span v-html="$t(`chat.confirmDialog.member.message.${channelAction}`, { textColor: this.getTextColor, memberName: member.name, channelName: channel.formatName() })"></span>
          </span>
          <span v-else v-html="$t('chat.confirmDialog.message', { channelAction: $t('chat.contextMenu')[channelAction], textColor: this.getTextColor, channelName: channel.formatName() })"></span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeDialog()"
          >
            {{ $t('chat.confirmDialog.btn.cancel') }}
          </v-btn>
          <v-btn
            :color="getColor"
            text
            class="action-channel-dialog-btn"
            @click="confirmAction()"
          >
            {{ $t(`chat.contextMenu.${channelAction}`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'chat-actionChannelDialog',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({
      roomSelected: 'chat/roomSelected',
      confirmDialog: 'chat/confirmChannelActionDialog',
      channel: 'chat/contextMenuChannel',
      channelAction: 'chat/contextMenuChannelAction',
      member: 'chat/contextMenuMember'
    }),
    getColor: function () {
      return this.channel?.conversationColorScheme()
    },
    getTextColor: function () {
      return `font-weight-bold ${this.getColor}--text`
    }
  },
  methods: {
    ...mapActions({
      closeDialog: 'chat/closeChannelActionDialog',
      archive: 'chat/archiveChannel',
      delete: 'chat/deleteChannel',
      restore: 'chat/restoreChannel',
      open: 'chat/openChannel',
      close: 'chat/closeChannel',
      join: 'chat/joinChannel',
      kick: 'chat/kickMemberFromChannel',
      addOwner: 'chat/addOwnerToChannel',
      removeOwner: 'chat/removeOwnerFromChannel',
      leave: 'chat/leaveChannel',
      resetRoom: 'chat/resetRoom'
    }),

    wordingFromOrTo () {
      return this.channelAction === 'add owner' ? 'to' : 'from'
    },

    confirmAction () {
      switch (this.channelAction) {
        case 'kick':
          this[this.channelAction](this.member?.id)
          break
        case 'add_owner':
          this.addOwner(this.member?.id)
          break
        case 'remove_owner':
          this.removeOwner(this.member?.id)
          break
        case 'leave':
        case 'close':
          this.exitRoom()
          this[this.channelAction]()
          break
        default:
          this[this.channelAction]()
      }
    },

    capitalizeFirstLetter (string) {
      return string?.charAt(0).toUpperCase() + string?.slice(1)
    },

    exitRoom () {
      if (this.roomSelected?.roomId === this.channel.id) {
        this.resetRoom()
        this.$router.push({ name: 'chats' })
      }
    }
  }
}
</script>

<style scoped>
</style>
